import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiConfig from "constants/apiConfig";
import { fetchCollaborationPermalinkFile } from "services/api/collaboration";
import { ERROR } from "types";

export interface PermalinkFilesSlice {
    loading: boolean,
    error: string | null,
    files: Record<string, Record<string, {
        url: string
    }>>
} 

const initialState: PermalinkFilesSlice = {
    loading: true,
    error: null,
    files: {}
}

const STALE_TIME = apiConfig.FETCH_COLLABORATION_PERMALINK_FILE.staleTime;

export const fetchPermalinkFile = createAsyncThunk(
    'collaboration/permalink-file',
    async ({campaignId, collaborationId, hubId, permalink}: {campaignId: string, collaborationId: string, hubId: string, permalink: string}, {getState, rejectWithValue}) => {
        const state = getState() as {permalinkFiles: PermalinkFilesSlice};
        if(state.permalinkFiles.files[campaignId]?.[permalink]){
            return {permalink, file: state.permalinkFiles.files[campaignId][permalink], campaignId};
        }
        try {
            const file = await fetchCollaborationPermalinkFile(hubId, campaignId, collaborationId, permalink);
            return {permalink, file, campaignId};
        } catch (error) {
            return rejectWithValue(ERROR.NOT_FOUND);
        }
    }
)

const permalinkFiles = createSlice({
    name: 'permalinkFiles',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchPermalinkFile.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(fetchPermalinkFile.rejected, (state) => {
            state.loading = false;
        })
        .addCase(fetchPermalinkFile.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;

            const {campaignId, permalink, file} = action.payload;

            state.files[campaignId] = {
                ...(state.files[campaignId] ?? {}),
                [permalink]: file
            }
        })
    }
})

export default permalinkFiles.reducer